import { render, staticRenderFns } from "./sky-input-button.vue?vue&type=template&id=b37c062a&scoped=true"
import script from "./sky-input-button.vue?vue&type=script&lang=js"
export * from "./sky-input-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37c062a",
  null
  
)

export default component.exports